// Browser events shared by the OATRx Flow components.

// Socket.IO event published by the backend when steps are assigned / updated / unassigned.
export const FLOW_ASSIGNMENT_SOCKET_EVENT = 'oatrx-flow:assignment';

// Fired on window when the current user's flow changed (the Daily list refreshes itself).
export const FLOW_CHANGED_EVENT = 'oatrx:flow:changed';
